$ = require 'jquery'
BoardDisplayHelpers = require 'views/internal/board-display-helpers'
BoardSelectOrganizationForPermChangeView = require 'views/board-menu/board-select-organization-for-perm-change-view'
Confirm = require 'views/lib/confirm'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
l = require 'lib/localize'
boardMenuVisTemplate = require 'views/templates/board_menu_vis'

module.exports = class ChangeBoardVisibilityView extends View
  viewTitleKey: ->
    if @model.owned()
      'change visibility'
    else
      'visibility'

  tagName: 'ul'

  initialize: ->
    @listenTo(@model, 'change', @render)
    return

  className: 'pop-over-list'

  maxWidth: 370

  events:
    'click .js-select': 'selectVis'

  render: ->
    org = @model.getOrganization()
    company = org?.getEnterprise()

    @$el.html boardMenuVisTemplate
      canChange: @model.owned()
      current: @model.getPref('permissionLevel')
      hasSuperAdmins: org?.isFeatureEnabled('superAdmins')
      hasOrg: org?
      orgName: org?.get('displayName')
      privateRestricted: org? && !org?.canSetVisibility('private')
      orgRestricted: org? && !org?.canSetVisibility('org')
      publicRestricted: org? && !org?.canSetVisibility('public')
      hasCompany: company?
      companyName: company?.get('displayName')

    @

  selectVis: (e) ->
    Util.stop(e)

    $target = $(e.target).closest('.js-select')

    if $target.hasClass('disabled') || $target.closest('.js-disabled').length
      return

    setting = $target.attr('name')
    change = if @model.getPref('permissionLevel') != setting then 1 else 0

    if setting == 'public'
      Confirm.pushView 'public board confirmation',
        elem: e.target
        confirmBtnClass: 'primary'
        maxWidth: 370
        fxConfirm: (e) =>
          @model.setPref('permissionLevel', setting)
          @model.save()
          trackUe('board', 'sets', 'board visibility', '', 'to public', '', { boardid: @model.id, change: change })

      return

    if setting == 'org' && !@model.getOrganization()
      # show org picker
      PopOver.pushView
        view: BoardSelectOrganizationForPermChangeView
        options:
          model: @model
          modelCache: @modelCache
          disableNone: true
      return

    @model.setPref('permissionLevel', setting)
    @model.save()

    if setting == 'org'
      trackUe('board', 'sets', 'board visibility', '', 'to team', '', { boardid: @model.id, change: change })
    else
      trackUe('board', 'sets', 'board visibility', '', 'to private', '', { boardid: @model.id, change: change })


    PopOver.popView()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/change-board-visibility-view.coffee